module.exports = {
  MESSAGE: 'message',
  RESPONSES: {
    SUCCESS: 'Y',
    NOERROR: 0
  },
  REQUESTS: {
    TRANSACTION_ACTION: {
      AUTHORIZATION: 'Authorization',
      SALE: 'Sale',
      ORDER: 'Order',
      REFUND: 'Refund'
    }
  },
  DEVICE_FINGERPRINT:{
    PROFILE_COMPLETE: {
      DATA_SOURCE:{
        CARDINAL_DATA: "CardinalData",
        THREAT_METRIX: "ThreatMetrix",
        METHOD_URL: "MethodURL"
      }
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./constants/messages.js
// module id = 61
// module chunks = 5